<script setup>
const props = defineProps({
    value: String
})
</script>

<template>
    <span v-html="value"/>
</template>